/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDS5Zs%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D%0A._3hxITiYbGa%7Bborder-style%3Anone%7D%0A._0KLXru9r67%7Bbackground-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._0jFU0V4Jdh%7Bheight%3A2px%7D%0A._30huDKYbGa%7Bborder%3Anone%7D%0A._3SamIHNHnM%7Bmargin-block%3Avar(--ds-space-300%2C24px)%7D%0A._2YLqiKPgdg%7Bmargin-inline%3Avar(--ds-space-0%2C0)%7D%0A._0KLXruKcZT%7Bbackground-color%3Avar(--ds-background-neutral-hovered%2C%230b120e24)%7D");







import { HTMLAttributes } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- jsx is required by the @jsx pragma in this file.

type DividerProps = HTMLAttributes<HTMLHRElement> & {
  margin?: string;
};
const styles = {
  divider: "_0bjKvDS5Zs _3hxITiYbGa _0KLXru9r67 _0jFU0V4Jdh"
};
const DividerCompiledParity = ({
  margin,
  style,
  ...props
}: DividerProps) => <hr {...props} role="presentation"
// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- arbitrary margin values passed by consumers
style={{
  ...style,
  margin: margin ? margin : '1.714em 0'
}} className={ax([styles.divider])} />;
export const Divider = (props: DividerProps): JSX.Element => <DividerCompiledParity {...props} />;
const dividerStyles = {
  root: "_30huDKYbGa _0bjKvDS5Zs _3SamIHNHnM _2YLqiKPgdg _0KLXruKcZT _0jFU0V4Jdh"
};
type DividerCompiledProps = {
  margin?: string;
  height?: string;
};
export function DividerCompiled({
  margin,
  height
}: DividerCompiledProps): JSX.Element {
  return <hr role="presentation" style={{
    margin: margin ? margin : '1.714em 0',
    height: height ? height : '2px'
  }} className={ax([dividerStyles.root])} />;
}